export default {"src":"/_next/static/image/public/images/ic_send.8ff50b8baf424e4a652ed17b9aa68ea2.svg","height":27,"width":27};